"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = exports.logEvent = exports.LogLevel = void 0;
const Sentry = __importStar(require("@sentry/react"));
const getErrorMessage_1 = require("../utils/getErrorMessage");
var LogLevel;
(function (LogLevel) {
    LogLevel["Info"] = "info";
    LogLevel["Warning"] = "warning";
    LogLevel["Error"] = "error";
    LogLevel["Debug"] = "debug";
    LogLevel["Fatal"] = "fatal";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
const convertToSeverityLevel = (level) => {
    switch (level) {
        case LogLevel.Info:
            return "info";
        case LogLevel.Warning:
            return "warning";
        case LogLevel.Error:
            return "error";
        case LogLevel.Debug:
            return "debug";
        case LogLevel.Fatal:
            return "fatal";
        default:
            return "info";
    }
};
const logEvent = ({ message, level = LogLevel.Info, }) => {
    const severityLevel = convertToSeverityLevel(level);
    Sentry.captureMessage(message, severityLevel);
};
exports.logEvent = logEvent;
const logError = (error, context = {}) => {
    const errorMessage = (0, getErrorMessage_1.getErrorMessage)(error);
    const errorToLog = new Error(errorMessage);
    Sentry.captureException(errorToLog, {
        extra: Object.assign({}, context),
    });
};
exports.logError = logError;
